import { Grid, Paper, SxProps } from "@mui/material";
import { Children, FC, ReactNode, useContext } from "react";
import { v4 } from "uuid";
import {
  AppContextType,
  StateContext,
  StateContextType,
} from "../../context/ApplicationContext";
import {
  FieldConfiguration,
  FormRowConfiguration,
} from "../model/form-configuration";

const bgColor: string = "#ffffff";

const style: SxProps = {
  padding: 2,
  mx: 2,
  bgcolor: { bgColor },
};

const isFieldConfiguration = (
  elem:
    | FieldConfiguration
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
): boolean => "id" in elem;

const isPaperHidden = (
  configuration: FormRowConfiguration,
  applicationContext: AppContextType
): boolean => {
  let ret: boolean = false;

  const fieldConfs: FieldConfiguration[] = configuration.fields.filter(
    (
      elem:
        | FieldConfiguration
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    ): elem is FieldConfiguration => {
      return isFieldConfiguration(elem);
    }
  );
  ret = true;

  fieldConfs.forEach((conf: FieldConfiguration) => {

    ret = ret && applicationContext.fieldHide[conf.id];
  });

  return ret;
};

const FormRow: FC<{
  children: ReactNode;
  configuration: FormRowConfiguration;
}> = ({ children, configuration }) => {
  const stateCtx: StateContextType = useContext(StateContext);

  let hiddenDisplay: SxProps = isPaperHidden(
    configuration,
    stateCtx.applicationContext
  )
    ? { display: "none" }
    : {};

  return (
    <Grid justifyContent="flex-start" item xs={1} sm={2} md={4} lg={4} xl={8}>
      <Paper elevation={3} sx={{ ...style, ...hiddenDisplay }}>
        <Grid
          container
          spacing={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
          columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 4 }}
          justifyContent="flex-start"
        >
          {Children.toArray(children).map((child, index: number) => {
            return (
              <Grid
                justifyContent="flex-start"
                key={"grid-" + configuration.section.name + "-" + index}
                item
                xs={1}
                sm={1}
                md={1}
                lg={1}
                xl={2}
                zeroMinWidth
              >
                {child}
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default FormRow;
//FormRow.whyDidYouRender = true;
